<template>
  <validation-provider class="dropzone"
                       :name="name"
                       tag="div"
                       rules="required"
                       v-slot="{ validate, errors }">

    <div class="dropzone-zone"
         :class="{ 'dropzone-zone_has-error': !!errors.length }"
         @drop="handeFileDrop">
      <input ref="fileInput"
             type="file"
             accept=".csv,.xls,.xlsx"
             @change="handeFileChange($event) || validate($event)" />
      <template v-if="!value">
        <i class="mdi mdi-cloud-upload "></i>
      </template>
      <template v-else>
        <i class="mdi mdi-file"></i>
        <p class="dropzone-text">{{ fileName }}</p>
      </template>

      <p class="dropzone-text">{{dropzoneText}}</p>
      <p class="dropzone-file">{{$t('message.marketingGenerics.message.dropZoneFile')}}</p>

    </div>

    <p v-if="errors.length"
       class="dropzone-error-text">{{ errors[0]  }}</p>

  </validation-provider>
</template>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: {
    ValidationProvider,
  },

  data() {
    return {};
  },
  props: {
    value: {
      type: File,
    },
    name: {
      type: String,
    },
    shouldResetInput: {
      type: Boolean
    },
    text: {
      type: String,      
    }
  },

  watch: {
    shouldResetInput(val) {
      if(val) {
        this.resetFileInput()
      }
    },
    value(val) {
      if(!val) this.resetFileInput()
    },    
  },

  methods: {
    handeFileChange(event) {
      event.preventDefault();

      const hasFile = !!event.target.files.length;
      const hasDataTransfer =
        !!event.dataTransfer && !!event.dataTransfer.items.length;

      const file = hasFile
        ? event.target.files[0]
        : hasDataTransfer
        ? event.dataTransfer.items[0].getAsFile()
        : undefined;

      this.$emit("input", file);
    },
    handeFileDrop(event) {
      this.$refs.inputRef = event.dataTransfer.files;
    },
    resetFileInput() {
      this.$refs.fileInput.value = null
    }
  },  

  beforeCreate() {},

  computed: {
    fileName() {
      return this.value ? this.value.name : "";
    },
    dropzoneText() {
      return this.text || this.$t('message.marketingGenerics.message.dropZoneText')
    }
  },

  mixins: [],
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.dropzone {
  .dropzone-zone {
    width: 100%;
    text-align: center;
    border: 1px dashed $primary;
    background: #f0f2f8;
    padding: 25px 60px;
    border-radius: 28px;
    color: #707070;
    position: relative;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    i {
      font-size: 80px;
      color: #43425d;
      opacity: 0.1;
    }

    .dropzone-text {
      margin-bottom: 10px;
    }

    .dropzone-file {
      cursor: pointer;
      color: $primary;
      margin: 0;
      font-size: 12px;
    }

    input {
      position: absolute;
      cursor: pointer;
      opacity: 0;
      width: 100%;
      left: 0;
      top: 0;
      z-index: 10;
      max-height: none;
      height: 100%;
    }

    &.dropzone-zone_has-error {
      border-color: #ff4141;
    }
  }

  .dropzone-error-text {
    margin-top: 10px;
    color: #ff4141;
    font-size: 14px;
    text-align: left;
    margin-bottom: 0;
  }
}
</style>
